import React from "react";
import { Rect, Text } from "react-konva";

import { Color } from "../helpers";
import { State } from "../StateManager/state";
import { Point, Size } from "./types";

type Props = Readonly<{
  cells: React.ReactElement | undefined;
  label: string;
  point: Point;
  size: Size;
  taxonomy: State["taxonomy"];
  showZoneLabels: boolean;
}>;

const UnknownFill = Color.fromString("rgba(0.0, 0.0, 0.0, 0.2)");
const UnknownStroke = Color.fromString("rgba(0.0, 0.0, 0.0, 0.5)");

export const Zone = ({ cells, label, point, size, taxonomy, showZoneLabels }: Props) => {
  let fillColor = UnknownFill;
  let labelFillColor = UnknownFill;
  let strokeColor = UnknownStroke;
  if (label in taxonomy.rawLabels && taxonomy.rawLabels[label].color) {
    fillColor = taxonomy.rawLabels[label].color.copy();
    labelFillColor = taxonomy.rawLabels[label].color.copy();
    labelFillColor.alpha = 0.5;
    fillColor.alpha = Math.min(fillColor.alpha / 2, 0.40);
    strokeColor = taxonomy.rawLabels[label].color.copy();

    if (showZoneLabels) {
      fillColor.alpha = 0;
    }

    // People want the borders to be more visible.
    strokeColor.blue /=2
    strokeColor.red /=2
    strokeColor.green /=2
    strokeColor.alpha = 1
  }
  return (
    <>
      <Rect
        fill={fillColor.toRGBAString()}
        stroke={strokeColor.toRGBAString()}
        {...point}
        {...size}
        strokeWidth={1.0}
        opacity={1.0}
      />
      {(showZoneLabels && label != "text") && (
        <>
          <Rect
              x={point.x  + size.width + 1}
              y={point.y}
              width={label.length * 6 + 8} // crude estimate: 8px per char + padding
              height={13}
              fill="white"
              stroke="black"
              strokeWidth={0.5}
              cornerRadius={2}
          />
          <Rect
              x={point.x + size.width + 1}
              y={point.y}
              width={label.length * 6 + 8} // crude estimate: 8px per char + padding
              height={13}
              fill={labelFillColor.toRGBAString()}
              stroke="black"
              strokeWidth={0.5}
              cornerRadius={2}
          />
          <Text
            x={point.x + size.width + 4}
            y={point.y + 2}
            text={label}
            fontSize={10}
            fill="black"
          />
        </>
      )}
      {cells}
    </>
  );
};
Zone.displayName = "Zone";
